// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c2b2afdb","667":"4b994a2a","977":"d6805513"}[chunkId] + ".chunk.js";
};